// src/components/strumenti/ConversionePotenza.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

export default function ConversionePotenza() {
  const [valore, setValore] = useState("");
  const [unita, setUnita] = useState("kW");

  const num = leggiNumero(valore) || 0;
  const inWatt = unita === "W" ? num : unita === "kW" ? num*1000 : num*1000000;

  const risultati = [
    { label: "W", val: inWatt },
    { label: "kW", val: inWatt/1000 },
    { label: "MW", val: inWatt/1000000 },
  ];

  const fmt = n => {
    if (n === 0) return "0";
    const abs = Math.abs(n);
    return abs >= 1000 ? n.toLocaleString("it-IT", {maximumFractionDigits:2}) : n.toLocaleString("it-IT", {maximumFractionDigits:6});
  };

  return (
    <div>
      <div style={{ display:"flex", gap:8, marginBottom:16 }}>
        <input value={valore} onChange={e=>setValore(e.target.value)} placeholder="Valore"
          style={{ flex:1, padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}/>
        <select value={unita} onChange={e=>setUnita(e.target.value)}
          style={{ padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}>
          <option value="W">W</option>
          <option value="kW">kW</option>
          <option value="MW">MW</option>
        </select>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
        {risultati.map(r => (
          <div key={r.label} style={{ background: r.label===unita?"#faf5ff":"#f9fafb", border:`1px solid ${r.label===unita?"#e9d5ff":"#e5e7eb"}`, borderRadius:10, padding:"12px 10px", textAlign:"center" }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{r.label}</div>
            <div style={{ fontSize:16, fontWeight:800, color: r.label===unita?"#7c3aed":"#111827" }}>{fmt(r.val)}</div>
          </div>
        ))}
      </div>
      <button onClick={()=>{setValore("");setUnita("kW");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
